import { useEffect, useRef } from 'react';
import { analytics } from '@/lib/analytics';

const THRESHOLDS = [25, 50, 75, 100] as const;

export function useScrollDepth(slug: string) {
  const firedRef = useRef<Set<number>>(new Set());
  const startTimeRef = useRef<number>(Date.now());

  useEffect(() => {
    firedRef.current = new Set();
    startTimeRef.current = Date.now();

    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (docHeight <= 0) return;

      const percent = Math.round((scrollTop / docHeight) * 100);

      for (const threshold of THRESHOLDS) {
        if (percent >= threshold && !firedRef.current.has(threshold)) {
          firedRef.current.add(threshold);
          analytics.articleScrollDepth(slug, threshold);

          if (threshold === 100) {
            const timeSpent = Math.round((Date.now() - startTimeRef.current) / 1000);
            analytics.articleCompleted(slug, timeSpent);
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [slug]);
}
